import React, { createContext, useContext, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { cloneDeep, set } from 'lodash';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { useTranslation } from 'react-i18next';
import * as careLabelAction from '../store/CARELABEL.action';
import { fetchTrafficLights } from '../../Bom/store/BOMConfig.action';
import { checkArray, imageUrl } from '../../../../Components/helper';

export const StateContext = createContext(null);

const careTypeOption = [
  { id: 'Wash', label: 'Wash' },
  { id: 'Bleach', label: 'Bleach' },
  { id: 'Dry', label: 'Dry' },
  { id: 'Iron', label: 'Iron' },
  { id: 'Professional care', label: 'Professional care' },
  { id: 'Other', label: 'Other' },
];
const disclaimerTypeOption = [
  { id: 'Wash', label: 'Wash' },
  { id: 'Caution', label: 'Caution' },
  { id: 'Warning', label: 'Warning' },
  { id: 'Appearance', label: 'Appearance' },
  { id: 'Animal Parts', label: 'Animal Parts' },
  { id: 'Other', label: 'Other' },
];

export default function CareUserInstructionStateProvider({ children }) {
  const params = useParams();
  const dispatch = useDispatch();
  const careType = params?.careType;
  const devOrderId = params?.devOrderId;
  const reducerState = useSelector((redState) => redState);
  const {
    CareLabelProductReducer: { productDetails, careList, isVisibleToSupplier },
    UserDetails: { isSupplierLoggedIn },
  } = reducerState;
  const initialSetting = {
    devOrderData: null,
    comment: '',
    commentSwitch: false,
    loader: true,
    activeCareType: null,
    CareLabelList: [],
    isComplete: false,
    pageLoader: false,
    imgPath: imageUrl,
    careTypeTabs: [
      { id: 'symbol', label: 'Symbols', isActive: false, isToggleSwitch: false },
      { id: 'instruction', label: 'Instruction', isActive: false, isToggleSwitch: false },
      { id: 'disclaimer', label: 'Disclaimer', isActive: false, isToggleSwitch: false },
      { id: 'layout', label: 'Care Label Layouts', isActive: false, isToggleSwitch: false },
    ],
    CareLibraryList: [],
    selectedLibrary: [],
    addCareProdcutTemplate: {
      image: '',
      fullImage: '',
      code: '',
      description: '',
      type: '',
      editMode: true,
      newItem: true,
      errors: [],
    },
    editedId: '',
    binaryImage: '',
    removeImage: false,
    initialLoader: false,
    symbolList: [],
    searchText: '',
    productModal: false,
    imageFileError: false,
  };

  const [CareLabelstate, setCareLabelState] = useState({ ...initialSetting });
  const { addCareProdcutTemplate, CareLabelList } = CareLabelstate;
  const { UserInstructionDetails } = useSelector((state) => state);
  const { tabData } = UserInstructionDetails;
  const initialValues = {
    searchText: '',
    tabId: '',
    tabName: '',
    columns: [],
    tabData: [],
    selectedIdArray: [],
    isSelectAll: false,
    editingRowId: '',
    addNewRow: false,
    showButtons: false,
    showImageUpload: false,
    selectedImageRowIndex: '',
    selectedImageRowColumnId: '',
    rowImage: null,
    showImgDeleteModal: false,
    showCareLayout: false,
  };
  const [userState, setUserState] = useState(initialValues);
  const [saveClicked, setSaveClicked] = useState(false);

  const rows = userState?.tabData;
  const findIndex = CareLabelList?.findIndex((item) => item?.tabId === userState?.tabId);
  useEffect(() => {
    setCareLabelState((prev) => ({
      ...prev,
      devOrderData: productDetails,
    }));
  }, [productDetails]);

  useEffect(() => {
    if (careList?.tabs?.length > 0) {
      console.log('careList?.tabss', careList?.tabs);
      const tabSwitch = cloneDeep(careList?.tabs);
      const switchData = tabSwitch.map((tab) => {
        return { ...tab, isToggleSwitch: productDetails?.visibleToSupplier };
      });
      if (isSupplierLoggedIn && productDetails?.visibleToSupplier) {
        setCareLabelState((prev) => ({
          ...prev,
          CareLabelList: switchData,
        }));
        setUserState((prevState) => ({
          ...prevState,
          tabId: careList?.tabs?.[0]?.tabId,
        }));
      } else if (!isSupplierLoggedIn) {
        setCareLabelState((prev) => ({
          ...prev,
          CareLabelList: switchData,
        }));
      }

      if (!userState.tabId && !isSupplierLoggedIn) {
        setUserState((prevState) => ({
          ...prevState,
          tabId: careList?.tabs?.[0]?.tabId,
        }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisibleToSupplier, careList, isSupplierLoggedIn]);

  useEffect(() => {
    const callFn = async () => {
      setCareLabelState((prevState) => ({
        ...prevState,
        pageLoader: true,
        initialLoader: true,
      }));
      const fetchParams = {
        type: 'care-label',
        devOrderId,
      };
      await dispatch(careLabelAction.fetchProductDetails(devOrderId));
      await dispatch(fetchTrafficLights(devOrderId));
      const res = await dispatch(careLabelAction.fetchOrderPermission(fetchParams));
      if (res) {
        setCareLabelState((prevState) => ({
          ...prevState,
          pageLoader: false,
          initialLoader: false,
        }));
      }
    };
    callFn();
  }, [dispatch, devOrderId]);

  const handleSelectAll = () => {
    const allRowIds = CareLabelList?.[findIndex]?.tabDetails?.map((detail) => detail.rowId);
    const uniqueRowIds = [...new Set(allRowIds)];

    const SelectedIds = userState?.isSelectAll ? [] : uniqueRowIds;

    setUserState((prevState) => ({
      ...prevState,
      selectedIdArray: SelectedIds,
      isSelectAll: !userState?.isSelectAll,
    }));
  };

  const handleRowSelection = (rowId) => {
    let updatedSelectedIds = [...userState.selectedIdArray];

    if (updatedSelectedIds.includes(rowId)) {
      updatedSelectedIds = updatedSelectedIds.filter((id) => id !== rowId);
    } else {
      updatedSelectedIds.push(rowId);
    }

    // Get unique row IDs to check for selection status
    const uniqueRowIds = [...new Set(CareLabelList?.[findIndex]?.tabDetails?.map((detail) => detail.rowId))];
    const allRowsSelected = updatedSelectedIds.length === uniqueRowIds.length;

    setUserState((prevState) => ({
      ...prevState,
      selectedIdArray: updatedSelectedIds,
      isSelectAll: allRowsSelected,
    }));
  };

  const getTabDetails = async () => {
    setUserState((prevState) => ({
      ...prevState,
      loading: true,
    }));

    setUserState((prevState) => ({
      ...prevState,
      loading: false,
    }));
  };

  useEffect(() => {
    if (Array.isArray(tabData)) {
      const groupedData = tabData?.reduce((acc, item) => {
        acc[item?.rowIndex] = acc[item?.rowIndex] || [];
        acc[item?.rowIndex]?.push(item);
        return acc;
      }, {});

      const transformedTabData = Object?.values(groupedData);
      setUserState((prevState) => ({
        ...prevState,
        tabData: transformedTabData,
      }));
    }
  }, [tabData]);

  const fetchCareLabelData = async () => {
    const typeObj = {
      devOrderId,
    };
    const updateNewObj = careType === 'disclaimer' ? { disclaimerType: '' } : { careType: '' };
    const response = await dispatch(careLabelAction.fetchCareInstructionProduct(typeObj));

    if (response) {
      setCareLabelState((prevState) => ({
        ...prevState,
        pageLoader: false,
        addCareProdcutTemplate: { ...addCareProdcutTemplate, ...updateNewObj, type: careType, errors: [] },
      }));
    }
  };

  useEffect(() => {
    const callFn = async () => {
      setCareLabelState((prevState) => ({
        ...prevState,
        pageLoader: true,
      }));
      const updatedArray = CareLabelstate.careTypeTabs.map((item) => {
        if (item.id === careType) {
          return { ...item, isActive: true };
        }
        if (item.id !== careType) {
          return { ...item, isActive: false };
        }
      });
      await fetchCareLabelData();
      setCareLabelState((prevState) => ({
        ...prevState,
        careTypeTabs: updatedArray,
        activeCareType: careType,
      }));
    };
    callFn();
  }, [dispatch]);

  const handleCheckAll = async (e) => {
    if (e.target.checked) {
      const allIds = CareLabelstate.CareLabelList && checkArray(CareLabelstate.CareLabelList) && CareLabelstate.CareLabelList.map((ele) => ele._id);
      if (allIds) {
        setCareLabelState((prevState) => ({
          ...prevState,
          selectedLibrary: allIds,
        }));
      }
    } else {
      setCareLabelState((prevState) => ({
        ...prevState,
        selectedLibrary: [],
      }));
    }
  };

  const handleCheckLibrary = async (isLibChecked, libId) => {
    const existingIds = CareLabelstate?.selectedLibrary;
    if (isLibChecked && !existingIds.includes(libId)) {
      setCareLabelState((prevState) => ({
        ...prevState,
        selectedLibrary: [...existingIds, libId],
      }));
    } else {
      const removedArray = existingIds?.filter((eleId) => eleId !== libId);
      if (checkArray(removedArray)) {
        setCareLabelState((prevState) => ({
          ...prevState,
          selectedLibrary: removedArray,
        }));
      } else {
        setCareLabelState((prevState) => ({
          ...prevState,
          selectedLibrary: [],
        }));
      }
    }
  };

  const handleAddCareLabel = () => {
    if (!userState?.showButtons) {
      const tabDetails = [];
      const foundTabIndex = CareLabelstate?.CareLabelList?.findIndex((item) => item?.tabId === userState?.tabId);
      const lastIndex =
        CareLabelstate?.CareLabelList?.[foundTabIndex]?.tabDetails?.length > 0 ? CareLabelstate?.CareLabelList?.[foundTabIndex]?.tabDetails?.length - 1 : 0;
      const lastRowIndex =
        CareLabelstate?.CareLabelList?.[foundTabIndex]?.tabDetails?.length > 0
          ? CareLabelstate?.CareLabelList?.[foundTabIndex]?.tabDetails[lastIndex].rowIndex
          : 0;
      if (CareLabelstate?.CareLabelList?.[foundTabIndex]?.tabColumns?.length > 0) {
        CareLabelstate?.CareLabelList?.[foundTabIndex]?.tabColumns?.forEach((column) => {
          tabDetails?.push({
            tabId: userState?.tabId,
            rowIndex: CareLabelstate?.CareLabelList?.[foundTabIndex]?.tabDetails?.length > 0 ? lastRowIndex + 1 : 0,
            columnId: column?._id,
            value: null,
          });
          setSaveClicked(false);
        });
      }
      const updatedCareLabelList = (CareLabelstate?.CareLabelList || []).map((item, index) => {
        if (index === foundTabIndex) {
          return {
            ...item,
            tabDetails: [...item.tabDetails, ...tabDetails], // Push the new tabDetails
          };
        }
        return item;
      });

      // Update the state with the modified CareLabelList
      setCareLabelState((prevState) => ({
        ...prevState,
        CareLabelList: updatedCareLabelList, // Set the updated list
      }));
      setUserState((prevState) => ({
        ...prevState,
        addNewRow: true,
      }));
    }
  };

  const isallChecked = !!(checkArray(CareLabelstate.CareLabelList) && CareLabelstate?.selectedLibrary.length === CareLabelstate.CareLabelList.length);

  const handleInputChange = (inputVal, element, index) => {
    const dataList = CareLabelstate.CareLabelList;
    const keyName = inputVal.target.name;

    set(dataList, `[${index}][${keyName}]`, inputVal.target.value);
    setCareLabelState((prevState) => ({
      ...prevState,
      CareLabelList: dataList,
    }));
  };

  const handleSelectChange = (selectValue, element, keyName, index) => {
    const dataList = CareLabelstate?.CareLabelList;

    set(dataList, `[${index}][${keyName}]`, selectValue?.id || '');
    setCareLabelState((prevState) => ({
      ...prevState,
      CareLabelList: dataList,
    }));
  };

  const contextValue = {
    CareLabelstate,
    setCareLabelState,
    isallChecked,
    handleCheckLibrary,
    handleCheckAll,
    handleAddCareLabel,
    handleInputChange,
    handleSelectChange,
    careTypeOption,
    disclaimerTypeOption,
    getTabDetails,
    userState,
    setUserState,
    rows,
    handleRowSelection,
    handleSelectAll,
    saveClicked,
    setSaveClicked,
  };

  return (
    <StateContext.Provider
      value={{
        ...contextValue,
      }}
    >
      {children}
    </StateContext.Provider>
  );
}

export function useCareInstructionState() {
  const { t } = useTranslation('common');
  const context = useContext(StateContext);
  if (!context) {
    throw new Error(t('TAKING_DATES.USE_STATE_MESSAGE'));
  }
  return context;
}
